import { render, staticRenderFns } from "./BranchProductAnalysis.vue?vue&type=template&id=36dddd49&scoped=true"
import script from "./BranchProductAnalysis.vue?vue&type=script&lang=js"
export * from "./BranchProductAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BranchProductAnalysis.vue?vue&type=style&index=0&id=36dddd49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dddd49",
  null
  
)

export default component.exports